<div *ngIf="isIe" class="banner">
    <svg id="icon" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
        <polygon points="17 22 17 14 13 14 13 16 15 16 15 22 12 22 12 24 20 24 20 22 17 22"/>
        <path d="M16,8a1.5,1.5,0,1,0,1.5,1.5A1.5,1.5,0,0,0,16,8Z"/>
        <path d="M16,30A14,14,0,1,1,30,16,14,14,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12,12,0,0,0,16,4Z"/>
    </svg>

    <p>It looks like you're using Internet Explorer. Please use an alternative browser such as Google Chrome, Microsoft Edge, Apple Safari or Mozilla Firefox as Internet Explorer is not compatible with our e-commerce platform.</p>
</div>